import { captureException } from '@sentry/react';
import { queryParamUtils } from './readQueryParamFromURL';
let hasInitialized = false;
export const initReturnUriBackHandler = () => {
    if (typeof window === 'undefined' || hasInitialized)
        return;
    hasInitialized = true;
    const returnUri = queryParamUtils.get('return_uri');
    if (!returnUri)
        return;
    if (window.location.href === returnUri)
        return;
    const sessionKey = 'hasPushedReturnUri';
    const alreadyPushed = sessionStorage.getItem(sessionKey);
    if (!alreadyPushed) {
        // Mark current page as original page with replaceState
        window.history.replaceState({ isOriginalPage: true }, '', window.location.href);
        // Push dummy state on top of current history stack
        window.history.pushState({ isDummy: true, returnUri }, '', window.location.href);
        try {
            sessionStorage.setItem(sessionKey, 'true');
        }
        catch (e) {
            if (!(e instanceof DOMException && (e.name === 'QuotaExceededError' || e.name === 'SecurityError'))) {
                captureException(e);
            }
        }
    }
    // Popstate handler fires on back/forward navigation
    const handlePopState = (event) => {
        const state = event.state;
        if (state?.isDummy && state.returnUri) {
            try {
                sessionStorage.removeItem(sessionKey);
            }
            catch (e) {
                captureException(e);
            }
            window.removeEventListener('popstate', handlePopState);
            // Redirect to returnUri — replace so user can’t go back to dummy state
            window.location.replace(state.returnUri);
        }
    };
    window.addEventListener('popstate', handlePopState);
    // Remove listener on page unload to avoid leaks
    window.addEventListener('beforeunload', () => {
        window.removeEventListener('popstate', handlePopState);
    });
};
